<template id="countdown-template">
  <div
    v-if="Number(minutes) < 20"
    class="countdown mr-4 white--text checkout-h4"
  >
    <p
      class="digit"
      style="font-weight: 450"
      :style="{ color: color }"
      v-if="showLabel && $vuetify.breakpoint.mdAndUp"
    >
      {{ $t("countdown.finishBy") }}
    </p>
    <v-icon v-else color="white" small class="mr-1 mb-1"
      >mdi-clock-time-three-outline</v-icon
    >
    <p class="digit" style="font-weight: 450" :style="{ color: color }">
      {{ minutes | two_digits }}:{{ seconds | two_digits }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["showLabel", "color", "orderDetails"],
  mounted() {
    window.setInterval(() => {
      this.now = Math.trunc(new Date() / 1000);
    }, 1000);
  },
  data() {
    return {
      now: Math.trunc(new Date() / 1000),
    };
  },
  computed: {
    ...mapGetters(["secure3dsOpen"]),

    dateInMilliseconds() {
      return this.date / 1000;
    },
    seconds() {
      return (this.dateInMilliseconds - this.now) % 60;
    },
    minutes() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
    },
    hours() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
    },
    days() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
    },
    date() {
      return (
        this.orderDetails.data * 1000 +
        (this.orderDetails.segundos_expiracao_pedido / 60) * 60 * 1000
      );
    },
  },
  watch: {
    now() {
      if (
        this.now > this.dateInMilliseconds &&
        this.dateInMilliseconds !== 0 &&
        !this.secure3dsOpen
      ) {
        this.$store.dispatch("setExpirationDialog", true);
      }
    },
  },
};
</script>

<style scoped>
.countdown {
  display: flex;
}

.digit {
  margin: 2px;
}
</style>
